/* eslint-disable @typescript-eslint/naming-convention */

export interface OnBoardingResponse {
  onboarding_type: OnBoardingType;
  onboarding_role: OnBoardingRole;
  company_code: string;
  completed: boolean;
}

export interface OnBoardingVideosResponse {
  title: string;
  url: string;
  thumbnail: string;
}

export enum OnBoardingType {
  OFFICE = 'O',
  WAREHOUSE = 'A',
  STORE = 'S',
  HIVE = 'C'
}

export enum OnBoardingRole {
  NEW = 'N',
  REPEATER = 'R'
}

export enum OnBoardingVideoType {
  FORMATIVE = 'FORMATIVE',
  INFORMATIVE = 'INFORMATIVE'
}
